import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import CountrySelectInput from "../shared/countrySelectInput";
import { addDoc, collection, deleteDoc, doc } from "firebase/firestore";
import { db } from "../../config/firebase";
import { toast } from "react-toastify";
import { useQuery } from "@tanstack/react-query";
import { getDirectories } from "../../lib/directory";
import { TiDelete } from "react-icons/ti";
import  {useSlowScroll } from "../../hooks/useSlowScroll";
const UnloadAddress = ({ formData, handleChange, setFormData, invalidUnloadAddressFields, setInvalidUnloadAddressFields }) => {
  // console.log(formData)
  const [loading, setLoading] = useState(false);
  const [selectedDirectory, setSelectedDirectory] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredDirectories, setFilteredDirectories] = useState([]);

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleInputChange = (e) => {
    e.stopPropagation();
    setSearchTerm(e.target.value.toLowerCase());
  };


  const handlePickUpTime = (field, e) => {
    const { value } = e.target;

    // Update the formData based on the field (startTime or endTime)
    setFormData((prevData) => {
      const updated = {
        ...prevData,
        unloadAddress_DeliveryTime: {
          ...prevData.unloadAddress_DeliveryTime,
          [field]: value,
        },
      };
      // If both times are set, clear the group error highlight
      const st = updated.unloadAddress_DeliveryTime?.startTime;
      const et = updated.unloadAddress_DeliveryTime?.endTime;
      if (st && et && setInvalidUnloadAddressFields) {
        setInvalidUnloadAddressFields((prev) =>
          prev.filter((k) => k !== "unloadAddress_DeliveryTime")
        );
      }
      return updated;
    });
  };



  // console.log('d', formData.loadAddress_PickUpTime)


  // console.log('dhhdhd', formData);
  const { data, isLoading, isError, refetch } = useQuery(
    ["dictories"], // Change the key to match the getUsers function
    async () => {
      const res = await getDirectories();
      return res;
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    if (searchTerm.trim() !== "") {
      setFilteredDirectories(
        data.filter((directory) =>
          Object.values(directory).some((value) =>
            typeof value === 'string' && value.toLowerCase().includes(searchTerm.toLowerCase())
          )
        )
      );
    } else {
      setFilteredDirectories(data);
    }
  }, [data, searchTerm]);



  const handleDirectory = (Id) => {
    const Directory = data.find(directory => directory.id === Id);
    setSelectedDirectory(Directory);
    setIsOpen(false);

  };
  useEffect(() => {
    function handleClickOutside(event) {
      const dropdownElement = document.querySelector('.unloadload-directory');
      if (dropdownElement && !dropdownElement.contains(event.target)) {
        setIsOpen(false);
      }
    }
  
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (selectedDirectory) {
      setFormData(prevFormData => ({
        ...prevFormData,
        unloadAddress_CompanyName: selectedDirectory.companyName || '',
        unloadPostalCode: selectedDirectory.postalCode || '',
        unloadCountry: selectedDirectory.country || '',
        unloadAddress_HouseNumber: selectedDirectory.houseNo || '',
        unloadAddress: selectedDirectory.address || '',
      }));
    }
  }, [selectedDirectory, setFormData]);


  const handleAddData = async (e) => {
    e.preventDefault(); // Prevent form submission from reloading the page
    // console.log(formData);
    try {
      setLoading(true);
      const directoryData = {
        companyName: formData.unloadAddress_CompanyName || '',
        country: formData.unloadCountry || '',
        postalCode: formData.unloadPostalCode || '',
        houseNo: formData.unloadAddress_HouseNumber || '', // Changed to 'loadAddress_HouseNo'
        address: formData.unloadAddress || '',
        loadAddress: false
      };
      // console.log('directory', directoryData);
      const directoryCollection = collection(db, 'directory'); // Changed to 'directory' collection
      await addDoc(directoryCollection, directoryData);
      refetch()
      toast.success("Address saved in Directory successfully!");
    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Error saving data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteDirectory = async (id) => {
    if (!id) return;
    try {
      const userRef = doc(db, "directory", id);
      await deleteDoc(userRef);

      toast.success("Directory Removed successfully");
      refetch();
    } catch (error) {
      console.error("Error deleting quotes", error);
      if (error.code === "not-found") {
        // Handle case when the document is not found
        toast.warning("User not found");
      } else {
        // Handle other errors
        toast.error(`Could not delete quotes: ${error.message}`);
      }
    }
  }
  const handleStartTimeWheel = useSlowScroll((e) => handlePickUpTime("startTime", e));
  const handleEndTimeWheel = useSlowScroll((e) => handlePickUpTime("endTime", e));

  // Confirm before changing Unload Country
  const [showUnloadCountryConfirm, setShowUnloadCountryConfirm] = useState(false);
  const [pendingUnloadCountry, setPendingUnloadCountry] = useState("");

  const handleUnloadCountryChange = (e) => {
    const next = e.target.value;
    const prev = formData.unloadCountry || "";
    if (prev && next !== prev) {
      setPendingUnloadCountry(next);
      setShowUnloadCountryConfirm(true);
      return;
    }
    handleChange(e);
  };

  return (
    <div>
      {/* first inputs */}

      <div className="grid grid-cols-1 gap-3 md:grid-cols-3">

        <div className="flex flex-col gap-1 py-2 w-full">
          <label className="w-full  text-sm font-normal" htmlFor="dropdown-button">
            Directory
          </label>
          <div className="relative group w-full h-8 z-50 unloadload-directory">
            <button
              id="dropdown-button"
              onClick={toggleDropdown}
              className="inline-flex justify-between w-full px-4 py-1 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500"
            >
              <span className="mr-2">Select Directory</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 ml-2 -mr-1"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M6.293 9.293a1 1 0 011.414 0L10 11.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
            <div
              id="dropdown-menu"
              className={`w-full absolute right-0 mt-2 rounded-md shadow-lg max-h-[40vh] overflow-y-auto bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1 ${isOpen ? '' : 'hidden'}`}
              onClick={(e) => e.stopPropagation()}
           >
              <input
                id="search-input"
                className="block w-full px-4 py-2 text-gray-800 border rounded-md  border-gray-300 focus:outline-none"
                type="text"
                placeholder="Search directories"
                autoComplete="off"
                value={searchTerm}
                onChange={handleInputChange}
              />
              {filteredDirectories && filteredDirectories.map((directory) => (
                <div
                  key={directory.id}
                  className="flex items-center justify-between px-4 py-2 cursor-pointer hover:bg-gray-100"
                  onClick={() => handleDirectory(directory.id)}
                >
                  <div>{directory?.companyName} , {directory?.country} </div>
                  <TiDelete
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteDirectory(directory.id);
                    }}
                    className="text-red-500 text-2xl"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-1 py-2">
          <label className="w-full text-sm font-normal" htmlFor="unloadAddress_ReferenceCustomer">
            Reference Customer <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            placeholder=""
            className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${
              invalidUnloadAddressFields.includes("unloadAddress_ReferenceCustomer") ? "border-red-500" : ""
            }`}
            id="unloadAddress_ReferenceCustomer"
            name="unloadAddress_ReferenceCustomer"
            onChange={handleChange}
            value={formData?.unloadAddress_ReferenceCustomer}
          />
        </div>
        <div className="flex flex-col gap-1 py-2">
          <label className="w-full text-sm font-normal" htmlFor="unloadAddress_CompanyName">
            Company Name 
          </label>
          <input
            type="text"
            placeholder=""
            className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${
              invalidUnloadAddressFields.includes("unloadAddress_CompanyName") ? "border-red-500" : ""
            }`}
            id="unloadAddress_CompanyName"
            name="unloadAddress_CompanyName"
            onChange={handleChange}
            value={formData?.unloadAddress_CompanyName}
          />
        </div>
      </div>
      {/* Confirmation modal for Unload Country change */}
      <Modal
        title="Confirm Country Change"
        open={showUnloadCountryConfirm}
        onOk={() => {
          handleChange({ target: { name: "unloadCountry", value: pendingUnloadCountry } });
          setShowUnloadCountryConfirm(false);
        }}
        onCancel={() => setShowUnloadCountryConfirm(false)}
        okText="Yes, change"
        cancelText="No"
      >
        <p>Are you sure you want to change the Unload Country?</p>
      </Modal>
      {/* Second inputs */}
      <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
        <div className="flex flex-col gap-1 py-2 mt-1">
          <CountrySelectInput
            label="Country"
            onChange={handleUnloadCountryChange}
            value={formData.unloadCountry}
            name="unloadCountry"
            id="unloadCountry"
          />
        </div>
        <div className="flex flex-col gap-1 py-2">
          <label className="w-full text-sm font-normal" htmlFor="unloadAddress_ContactName">
            Contact Name 
          </label>
          <input
            type="text"
            placeholder=""
             className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${
              invalidUnloadAddressFields.includes("unloadAddress_ContactName") ? "border-red-500" : ""
            }`}
            id="unloadAddress_ContactName"
            name="unloadAddress_ContactName"
            onChange={handleChange}
            value={formData?.unloadAddress_ContactName}
          />
        </div>

        <div className="flex flex-col gap-5  py-2 ">
          <div className="flex flex-col w-full gap-1 py-2">
            <label className="w-full text-sm font-normal" htmlFor="unloadPostalCode">
              Postal Code <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder=""
               className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${
              invalidUnloadAddressFields.includes("unloadPostalCode") ? "border-red-500" : ""
            }`}
              id="unloadPostalCode"
              name="unloadPostalCode"
              onChange={handleChange}
              value={formData?.unloadPostalCode}
            />
          </div>
          {/* <div className="flex flex-col w-full gap-1 py-2">
            <label className="w-full text-sm font-normal" htmlFor="name">
              House No.
            </label>
            <input
              type="text"
              placeholder=""
              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
              id="unloadAddress_HouseNumber"
              name="unloadAddress_HouseNumber"
              onChange={handleChange}
              value={formData?.unloadAddress_HouseNumber}
            />
          </div> */}
        </div>
      </div>
      {/* Second inputs */}

      {/* Three inputs */}
      <div className="grid grid-cols-1 gap-3 md:grid-cols-3">

        <div className="flex flex-col gap-1 py-2 lg:flex-row lg:flex-wrap">
          <div className="flex flex-col w-full gap-1 py-2">
            <label className="w-full text-sm font-normal" htmlFor="unloadAddress_DeliveryDate">
              Delivery date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              placeholder=""
              className={`h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${
                invalidUnloadAddressFields.includes("unloadAddress_DeliveryDate") ? "border-red-500" : ""
              }`}
              id="unloadAddress_DeliveryDate"
              name="unloadAddress_DeliveryDate"
              onChange={handleChange}
              value={formData?.unloadAddress_DeliveryDate}
              style={{ width: "100%" }}
            />
          </div>


          <div className="flex flex-col w-full gap-1 py-2 mt-4 ">
      <label className="w-full text-sm font-normal" htmlFor="unloadStartTime">
        Delivery Time <span className="text-red-500">*</span>
      </label>
      <div className="flex gap-2 items-center">
        Between
        <input
          type="time"
          placeholder=""
          className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${
            invalidUnloadAddressFields.includes("unloadAddress_DeliveryTime") &&
            !formData.unloadAddress_DeliveryTime?.startTime ? "border-red-500" : ""
          }`}
          id="unloadStartTime"
          name="startTime"
          onChange={(e) => handlePickUpTime("startTime", e)}
          onWheel={handleStartTimeWheel}
          value={formData.unloadAddress_DeliveryTime?.startTime || ""}
        /> to
        <input
          type="time"
          placeholder=""
          className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${
            invalidUnloadAddressFields.includes("unloadAddress_DeliveryTime") &&
            !formData.unloadAddress_DeliveryTime?.endTime ? "border-red-500" : ""
          }`}
          id="unloadEndTime"
          name="endTime"
          onChange={(e) => handlePickUpTime("endTime", e)}
          onWheel={handleEndTimeWheel}
          value={formData.unloadAddress_DeliveryTime?.endTime || ""}
        />
      </div>
    </div>
        </div>
        <div className="flex flex-col gap-1 py-2 mt-2">
          <label className="w-full text-sm font-normal" htmlFor="unloadAddress_PhoneNumber">
            Phone Number 
          </label>
          <input
            type="number"
            placeholder=""
            className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue`}
            id="unloadAddress_PhoneNumber"
            name="unloadAddress_PhoneNumber"
            onChange={handleChange}
            value={formData?.unloadAddress_PhoneNumber}
            pattern="(\+)?[\d\s-]{0,20}"
            minLength="0"
            maxLength="20"
          />
         
        </div>

        <div className="flex flex-col gap-1 py-2">
          <label className="w-full text-sm font-normal" htmlFor="unloadAddress">
            Address <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            placeholder=""
            className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${
              invalidUnloadAddressFields.includes("unloadAddress") ? "border-red-500" : ""
            }`}
            id="unloadAddress"
            name="unloadAddress"
            onChange={handleChange}
            value={formData?.unloadAddress}
          />
        </div>
      </div>
      {/* Three inputs */}

      {/* Four inputs */}
      <div className="grid grid-cols-1 gap-3 md:grid-cols-3">

        {/* <div className="flex flex-col gap-1 py-2">
          <label className="w-full text-sm font-normal" htmlFor="name">
            Issued Time
          </label>
          <input
            type="time"
            placeholder=""
            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
            id="unloadAddress_IssuedTime"
            name="unloadAddress_IssuedTime"
            onChange={handleChange}
            value={formData?.unloadAddress_IssuedTime}
          />
        </div> */}
        <button
          className=" text-sm px-2 py-1 h-10 text-[#fff] rounded-lg  w-28"
          style={{ background: "#053f92" }}
          onClick={handleAddData}
        >
          {loading ? 'Loading...' : 'Directory +'}
        </button>
      </div>
      {/* Four inputs */}

      <div className="flex flex-col gap-1 py-2">
        <label>Comments</label>
        <textarea className="border border-[#B3C5DF] h-[100px] rounded-lg  focus:outline-none p-2 " id="comments"
        style={{ fontSize: '14px' }}
          name="unloadAddress_Comments"
          onChange={handleChange}
          maxLength={500}
          value={formData?.unloadAddress_Comments} />
          
      </div>
    </div>
  );
};

export default UnloadAddress;
